import React from 'react';
import { Avatar, AvatarSize } from 'wix-ui-tpa';
import { useTranslate } from '../../../context/api-context/translations/use-translate';
import { classes } from './comment-box-footer.st.css';
export const CommentBoxFooter = ({ publishControls, currentMember, }) => {
    var _a;
    const t = useTranslate();
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.commentingAs }, currentMember && [
            React.createElement(Avatar, { size: AvatarSize.xSmall, src: (_a = currentMember.profile.photo) === null || _a === void 0 ? void 0 : _a.url }),
            React.createElement("div", { className: classes.name }, t('comment-box-footer.commenting-as', {
                name: currentMember.profile.nickname,
            })),
        ]),
        React.createElement("div", { className: classes.publishControls }, publishControls)));
};
//# sourceMappingURL=comment-box-footer.js.map